// Redux slice
import { createSlice } from "@reduxjs/toolkit";
import {
  getCountry,
  getCountryValue,
  getProvince,
  getProvinceDescription,
  getLocationWater,
  getDestination,
  getMarina,
  getNationality,
  getTrackingGoogle,
  getTrackingFacebook,
  getCompany,
  getPaymentConnection,
} from "../../API/CenterDataAPI";

const initialState = {
  Country: [],
  CountryValue: [],
  Province: [],
  ProvinceDescription: [],
  LocationWater: [],
  Destination: [],
  Marina: [],
  Nationality: [],
  TrackingGoogle: [],
  TrackingFacebook: [],
  Company: [],
  PaymentConnection: [],
};

export const CenterDataSlice = createSlice({
  name: "CenterDataState",
  initialState,
  reducers: {
    updateCountry: (state, action) => {
      state.Country = action.payload;
    },
    updateCountryValue: (state, action) => {
      state.CountryValue = action.payload;
    },
    updateProvince: (state, action) => {
      state.Province = action.payload;
    },
    updateProvinceDescription: (state, action) => {
      state.ProvinceDescription = action.payload;
    },
    updateLocationWater: (state, action) => {
      state.LocationWater = action.payload;
    },
    updateDestination: (state, action) => {
      state.Destination = action.payload;
    },
    updateMarina: (state, action) => {
      state.Marina = action.payload;
    },
    updateNationality: (state, action) => {
      state.Nationality = action.payload;
    },
    updateTrackingGoogle: (state, action) => {
      state.TrackingGoogle = action.payload;
    },
    updateTrackingFacebook: (state, action) => {
      state.TrackingFacebook = action.payload;
    },
    updateCompany: (state, action) => {
      state.Company = action.payload;
    },
    updatePaymentConnection: (state, action) => {
      state.PaymentConnection = action.payload;
    },
  },
});

export const {
  updateCountry,
  updateCountryValue,
  updateProvince,
  updateProvinceDescription,
  updateLocationWater,
  updateDestination,
  updateMarina,
  updateNationality,
  updateTrackingGoogle,
  updateTrackingFacebook,
  updateCompany,
  updatePaymentConnection,
} = CenterDataSlice.actions;

export const getCountryDetail = () => async (dispatch) => {
  await getCountry().then(async (data) => {
    await dispatch(updateCountry(data));
  });
};

export const getCountryValueDetail = () => async (dispatch) => {
  await getCountryValue().then(async (data) => {
    await dispatch(updateCountryValue(data));
  });
};

export const getProvinceDetail = () => async (dispatch) => {
  await getProvince().then(async (data) => {
    await dispatch(updateProvince(data));
  });
};

export const getProvinceDescriptionDetail = () => async (dispatch) => {
  await getProvinceDescription().then(async (data) => {
    await dispatch(updateProvinceDescription(data));
  });
};

export const getLocationWaterDetail = () => async (dispatch) => {
  await getLocationWater().then(async (data) => {
    await dispatch(updateLocationWater(data));
  });
};

export const getDestinationDetail = () => async (dispatch) => {
  await getDestination().then(async (data) => {
    await dispatch(updateDestination(data));
  });
};

export const getMarinaDetail = () => async (dispatch) => {
  await getMarina().then(async (data) => {
    await dispatch(updateMarina(data));
  });
};

export const getNationalityDetail = () => async (dispatch) => {
  await getNationality().then(async (data) => {
    await dispatch(updateNationality(data));
  });
};

export const getTrackingGoogleDetail = () => async (dispatch) => {
  await getTrackingGoogle().then(async (data) => {
    await dispatch(updateTrackingGoogle(data));
  });
};

export const getTrackingFacebookDetail = () => async (dispatch) => {
  await getTrackingFacebook().then(async (data) => {
    await dispatch(updateTrackingFacebook(data));
  });
};

export const getCompanyDetail = () => async (dispatch) => {
  await getCompany().then(async (data) => {
    await dispatch(updateCompany(data));
  });
};

export const getPaymentConnectionDetail = () => async (dispatch) => {
  await getPaymentConnection().then(async (data) => {
    await dispatch(updatePaymentConnection(data));
  });
};

export default CenterDataSlice.reducer;
